"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var empty_state_svg_1 = __importDefault(require("@assets/components/user/empty-state/empty-state.svg"));
var CreateButton_1 = __importDefault(require("./CreateButton"));
var useState = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        emptyStateContainer: (_a = {
                width: 234,
                margin: 'auto',
                marginTop: function (props) { return (!props.urlsFiltered ? 45 : 26); },
                marginBottom: 78
            },
            _a[theme.breakpoints.up('md')] = {
                width: 'unset',
                marginTop: function (props) { return (!props.urlsFiltered ? 85 : 45); },
                marginBottom: function (props) {
                    return !props.urlsFiltered ? 85 : 45;
                },
            },
            _a),
        headerText: {
            lineHeight: '25px',
            marginBottom: 0,
            fontWeight: 400,
            '&:last-child': {
                marginBottom: 21,
            },
        },
        emptyStateGraphic: {
            display: 'block',
            margin: 'auto',
        },
        createButtonDiv: {
            display: 'flex',
            justifyContent: 'center',
        },
    });
});
var EmptyState = function (_a) {
    var urlsFiltered = _a.urlsFiltered;
    var classes = useState({ urlsFiltered: urlsFiltered });
    return (react_1.default.createElement("div", { className: classes.emptyStateContainer },
        react_1.default.createElement("div", null,
            urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, "No results found, try expanding your search terms.")),
            !urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, "You do not have any short links yet.")),
            !urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, "Get started and customise one from an existing link or file!"))),
        react_1.default.createElement("img", { className: classes.emptyStateGraphic, src: empty_state_svg_1.default, alt: "No shortened links yet", draggable: false }),
        !urlsFiltered && (react_1.default.createElement("div", { className: classes.createButtonDiv },
            react_1.default.createElement(CreateButton_1.default, null)))));
};
exports.default = EmptyState;
